import { useState } from 'react';
import ReferenceEmploymentComparison from '../ReferenceEmploymentComparison';
import { ReferencesPanel } from '../../compliance';

/**
 * Operator-first: canonical reference requests, responses and manager decisions
 * are the primary workspace. Employer-name comparison is secondary evidence.
 * Mount it only when opened so it doesn't duplicate the active status or load
 * another document/API request every time staff open the References tab.
 */
export default function ReferencesTabContent({
  employeeId,
  employee,
  onRefresh,
  onEditReference,
}) {
  const [showEmployerComparison, setShowEmployerComparison] = useState(false);

  return (
    <div data-testid="references-tab-content" className="space-y-3">
      <ReferencesPanel
        employeeId={employeeId}
        employee={employee}
        onRefresh={onRefresh}
        onEditReference={onEditReference}
      />

      <section className="rounded-lg border border-slate-200 bg-white p-3" data-testid="reference-secondary-evidence">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div className="min-w-0">
            <p className="text-sm font-medium text-slate-800">Employer matching evidence</p>
            <p className="text-xs text-slate-600">
              Compare employer names when you need to investigate a mismatch. Reference decisions remain above.
            </p>
          </div>
          <button
            type="button"
            aria-expanded={showEmployerComparison}
            aria-controls="reference-employment-evidence"
            onClick={() => setShowEmployerComparison((visible) => !visible)}
            className="inline-flex shrink-0 items-center rounded-md border border-slate-300 px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
            data-testid="toggle-reference-employer-matching"
          >
            {showEmployerComparison ? 'Hide comparison' : 'Review employer matching'}
          </button>
        </div>
        <div
          id="reference-employment-evidence"
          hidden={!showEmployerComparison}
          className="mt-3"
          role="region"
          aria-label="Employer and reference comparison"
        >
          {showEmployerComparison && (
            <ReferenceEmploymentComparison
              key={employeeId}
              employeeId={employeeId}
              onRefresh={onRefresh}
            />
          )}
        </div>
      </section>
    </div>
  );
}
